import { useLocation } from 'react-router-dom';

interface IPath {
  from: { pathname: any };
}

export const protocol =
  process.env.NODE_ENV === 'development' ? 'http' : 'https';

const defaultLocationState: IPath = { from: { pathname: '/' } };

export function useRedirectTo(): IPath {
  const location = useLocation<IPath>();
  return location.state ?? defaultLocationState;
}
